<template>
    <div>
        <div class="page-title">Edit Quick Link</div>
        <div class="page-box">
        <quickLinkFrom :ruleForm="ruleForm"></quickLinkFrom>
        <el-button  type="warning" @click="onSubmit"> Submit </el-button>
        </div>
    </div>
</template>

<script>
    import {getQuickLinksDetail,editQuickLinks} from '@/api/admin/notification'
    import quickLinkFrom from './components/quickLinkFrom.vue'
    export default {
        components:{quickLinkFrom},
        props:{
            id:{
                type:Number,
                default:0
            }
        },
        data() {
            return {
                ruleForm: {
                   
                },
            }
        },
        created(){
            this.getQuickLinksDetail()
        },
        methods:{
            onSubmit(){
                this.editQuickLinks()
            },
            editQuickLinks(){
                editQuickLinks(this.id,this.ruleForm).then(()=>{
                    this.$message.success('Save success')
                })
            },
            getQuickLinksDetail(){
                getQuickLinksDetail(this.id).then((v)=>{
                     this.ruleForm = v.data
                })
            }
        }
        
    }
</script>

<style lang="scss" scoped>
.page-box{
    padding: 20px;
    background-color: #fff;
}
</style>